import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Pin from "../../../library/pin/Pin";
import UrlCorrectionBox from "./UrlCorrectionBox";
import { ReactComponent as SmsPhone } from "../../../assets/icons/PhoneSms.svg";
import { ReactComponent as ErrorIcon } from "../../../assets/img/error-icon.svg";
import { StyledPersonalAuthentication } from "../../../styles/PersonalAuthentication";
import { useTimer } from "../../../utils/utilityFunctions";
import { SmsValidationContent, ValidateLoginContainer } from "../views/signIn/styles";
import useDidUpdateEffect from "../../../utils/_hooks/useDidUpdateEffect";
import { ReactComponent as EmailIcon } from "../../../assets/icons/emailOtpIcon.svg";

const time = 60 * 1.5;

const ConfirmKudaAccount = ({
    pin,
    handleInputPinChange,
    showTokenValidationError,
    validationPhoneNumber,
    handleTokenConfirm,
    validateOtpState,
    errMsg,
    validationType,
    dispatchAction,
}) => {
    const [counterStarted, setCounterStarted] = useState(true);
    const [resending, setResending] = useState(false);
    const { minutes, seconds, restartTimer, clearTimer } = useTimer(time);

    const dispatch = useDispatch();
    const auditLogData = useSelector((state) => state.accountState.auditLogData);

    useDidUpdateEffect(() => {
        if (minutes === "00" && seconds === "00" && counterStarted && !resending) {
            setCounterStarted(false);
            clearTimer();
        }
    }, [seconds, minutes, counterStarted, resending]);

    const resendValidationMsg = async () => {
        setResending(true);

        const auditLog = {
            ...auditLogData,
            moduleName: "login",
            action: "sendLoginOTPValidation",
            description: "Send Otp to Customer during login ",
        };

        const payload = {
            notificationType: validationType,
            auditLogData: auditLog,
        };

        const { status } = await dispatch(dispatchAction(payload));

        if (status) {
            setTimeout(() => {
                restartTimer();
            }, 1000);

            setTimeout(() => {
                setResending(false);
                setCounterStarted(true);
            }, 3000);
        }
    };

    return (
        <div className="flex login-container--wrap">
            <ValidateLoginContainer>
                <div className="kuda-auth--layout">
                    <div className="auth-container">
                        <div className="animated kudaFadeInUp">
                            <h1 className="page-heading-title">
                                {validationType === 2
                                    ? "Confirm Your Phone Number"
                                    : "Confirm Your Email Address"}
                            </h1>
                        </div>

                        <div className="width-100">
                            <div className={`infinite-path width-wide ${!resending && "d-none"}`}>
                                <span id="elem" className="shape trail"></span>
                            </div>

                            <div className="flex align-start justify-between">
                                <StyledPersonalAuthentication className="width-100">
                                    <SmsValidationContent>
                                        <div className="bottom-spacer--md">
                                            {validationType === 2 ? <SmsPhone /> : <EmailIcon />}
                                        </div>

                                        {showTokenValidationError && (
                                            <div className="error-auth--label">
                                                <span className="auth-error-icon">
                                                    <ErrorIcon />
                                                </span>
                                                <span className="auth-error-text">{errMsg}</span>
                                            </div>
                                        )}

                                        <div className="sub-heading-text text-center">
                                            Please enter the OTP we just sent to
                                            <div className="bold-txt">
                                                {validationType === 2
                                                    ? `*********${validationPhoneNumber}`
                                                    : validationType === 3
                                                    ? validationPhoneNumber
                                                    : "your Kuda App"}
                                            </div>
                                        </div>

                                        <div className="personal-form confirm-otp--form mt-4">
                                            <div className="transaction-pin--wrap">
                                                <Pin
                                                    type={1}
                                                    name="currentPin"
                                                    onChange={handleInputPinChange}
                                                    size={5}
                                                />
                                            </div>
                                        </div>

                                        <div className="resend-txt text-center mx-auto">
                                            Didn’t get a code?{" "}
                                            {counterStarted ? (
                                                <>
                                                    Resending in{" "}
                                                    <span className="green-txt text-xlbold ml-1">
                                                        {minutes}:{seconds}
                                                    </span>
                                                </>
                                            ) : (
                                                <>
                                                    {resending ? (
                                                        <span>Resending...</span>
                                                    ) : (
                                                        <button
                                                            className="green-txt bg-white text-xlbold cursor-pointer"
                                                            onClick={resendValidationMsg}
                                                        >
                                                            Resend
                                                        </button>
                                                    )}
                                                </>
                                            )}
                                        </div>

                                        <div
                                            className={`sme-cta--primarybutton kuda-cta kuda-cta-md mx-auto ${
                                                !pin || pin.length < 5
                                                    ? "disable-dead"
                                                    : validateOtpState
                                                    ? "form-loading disable-dead"
                                                    : ""
                                            }`}
                                            onClick={handleTokenConfirm}
                                        >
                                            <span>Continue</span>
                                        </div>
                                    </SmsValidationContent>

                                    <UrlCorrectionBox className="mt-40" />
                                </StyledPersonalAuthentication>
                            </div>
                        </div>
                    </div>
                </div>
            </ValidateLoginContainer>
        </div>
    );
};

export default ConfirmKudaAccount;
